import { API_URL } from "@/config";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://af066890175230c072d8476e8b1b86d1@o4509196120162304.ingest.de.sentry.io/4509196135235664",
  environment: API_URL.includes("devapi") ? "DEV" : "PROD",
});

export default Sentry;
